import { Component, OnInit } from '@angular/core';
import { UserRegistrationService } from '../service/cognito.service';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-verfication',
  templateUrl: './verfication.component.html',
  styleUrls: ['./verfication.component.scss']
})
export class VerficationComponent implements OnInit {

  invalidVericationCodeMsg: string;
  user: any = {
    username: '',
    verificationcode: ''
  };
  loaderActivate: boolean;
  constructor(private authService: AuthService, private router: Router,
    public userRegistrationService: UserRegistrationService, private translate: TranslateService) {

   }
  ngOnInit() {
    this.translate.get('Register.VerificationCodeError').subscribe(error => {
      this.invalidVericationCodeMsg = error;
    });
    // this.invalidVericationCodeMsg = 'User is not confirmed yet, Please confirm the code here.';
  }
  onFormSubmit(model: any, isValid: boolean) {
    if (!isValid) {
     return;
   }
   this.invalidVericationCodeMsg = '';
   this.loaderActivate = true;
   this.authService.confirmEmailVerification(this.user.username, this.user.verificationcode).finally(() => {
     this.loaderActivate = false;
   }).subscribe(res => {
     if (res === 200) {
       this.router.navigate(['/login']);
       this.loaderActivate = false;
       this.CallBackendVerfication(this.user.verificationcode);
     } else if (res === 'CodeMismatchException') {
       this.invalidVericationCodeMsg = 'Invalid Verification Code.';
     }else if (res === 'ExpiredCodeException') {
       this.invalidVericationCodeMsg = 'Invalid Verification Code.';
     }else if (res === 'UserNotFoundException') {
       this.invalidVericationCodeMsg = 'User coudnot found.';
     } else {
       this.invalidVericationCodeMsg = 'Invalid Verification Code.';
     }

   }, err => {
     console.log(err);
   });
    // this.userRegistrationService.confirmRegistration(this.user.username, this.user.verificationcode, this);
  }

  // reSendVerificationCode(): void {
  //   // tslint:disable-next-line:prefer-const
  //   let verifcationEmail = localStorage.getItem('verificationUserName');
  //   this.userRegistrationService.resendCode(verifcationEmail, this);
  // }

   // Call Resend Option
   reSendVerificationCode(): void {
     if (this.user.username === '' || this.user.username === null || this.user.username === undefined) {
      this.invalidVericationCodeMsg = 'Please enter the username or email';
       return;
     }

    this.authService.resendEmailVerification(this.user.username).subscribe(res => {
      if (res === 200) {
       // this.invalidVericationCodeMsg = 'Successfully Resend code.';
        this.translate.get('Register.SuccessfullyResendCode').subscribe(error => {
          this.invalidVericationCodeMsg = error;
        });
      } else if (res === 'CodeDeliveryFailureException') {
        this.invalidVericationCodeMsg = 'when a verification code fails to deliver successfully.';
      }else if (res === 'UserNotFoundException') {
        this.invalidVericationCodeMsg = 'User is not found.';
      }else if (res === 'InternalErrorException') {
        this.invalidVericationCodeMsg = 'Internal Server Error.';
      }else if (res === 'InvalidParameterException') {
        this.invalidVericationCodeMsg = 'Invalid Parameter.';
      }else {
        this.invalidVericationCodeMsg = 'when a verification code fails to deliver successfully.';
      }
    }, err => {
      this.invalidVericationCodeMsg = err;
      console.log(err);
    });
  }

  cognitoVerificationCallback(message: string, result: any) {
    if (message != null) { // error
      this.invalidVericationCodeMsg = message;
    } else { // success
      this.router.navigate(['/login']);
      this.CallBackendVerfication(localStorage.getItem('verificationUserName'));
    }
  }

  CognitoResendCallback(message: string, result: any) {
    if (message != null) { // error
      this.invalidVericationCodeMsg = message;
    } else { // success
     // this.invalidVericationCodeMsg = 'Successfully Resend code';
      this.translate.get('Register.SuccessfullyResendCode').subscribe(error => {
        this.invalidVericationCodeMsg = error;
      });
    }
  }

  CallBackendVerfication(params: string) {
    this.authService.active_User(params).subscribe(res => {
      if (res != null) {
        console.log(res);
      }
    }, err => {
      console.log(err);
    });
  }


  // Go to Login
  goToLogin(): void {
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/verfication/verfication.component.ts